import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ApiService } from '../api/api.service';
import { AuthenticationManager } from './authenticationManager';
import { map } from 'rxjs/operators';
import { CommonRequest } from '../../models/common/common.request';
import { TokenTimerService } from './token-timer.service';

@Injectable()
export class AuthenticationService {
    constructor(
        private apiService: ApiService,
        private authenticationManager: AuthenticationManager,
        private tokenTimerService: TokenTimerService
    ) {}

    refreshToken(request: any): Observable<any> {
        return this.apiService.refTokenPost('auth/refreshToken', request).pipe(
            map((refreshResponse) => {
                if (refreshResponse) {
                    if (refreshResponse.data) {

                        this.authenticationManager.saveAuth(refreshResponse.data);

                         const popupTime = new Date(refreshResponse.data.tokenExpiryTime).getTime()- (1 * 60 * 1000);
                         this.tokenTimerService.schedulePopup(popupTime);
                    }
                    return refreshResponse;
                } else {
                    return throwError(() => new Error(refreshResponse.error));
                }
            })
        );
    }

    attemptAuth(authRequest: any): Observable<any> {
        return this.apiService.post(`auth/login`, authRequest).pipe(
            map((authenticationResponse) => {
                if (authenticationResponse) {
                    if (authenticationResponse.data) {
                        this.authenticationManager.saveAuth(authenticationResponse.data);
                        this.tokenTimerService.schedulePopup(authenticationResponse.data.tokenExpiryTime);
                    }
                    return authenticationResponse;
                } else {
                    return throwError(() => new Error(authenticationResponse.error));
                }
            })
        );
    }

    fetchUser(commonRequest: CommonRequest): Observable<any> {
        return this.apiService.get(`auth/login/user`, commonRequest).pipe(
            map((userResponse) => {
                if (userResponse) {
                    if (userResponse.hasOwnProperty('data')) {
                        this.authenticationManager.saveUser(userResponse.data);
                        sessionStorage.setItem('currentUser', userResponse.data);
                        return userResponse;
                    }
                } else {
                    return throwError(() => new Error(userResponse.error));
                }
            })
        );
    }

    // fetchUserByUserId(fetchUserRequest:any): Observable<any> {
    //     return this.apiService.post(`auth/login/fetch-user`, fetchUserRequest).pipe(map(
    //         userResponse => {
    //             if (userResponse) {
    //                 if (userResponse.hasOwnProperty('data')) {
    //                     this.authenticationManager.saveUser(userResponse.data);
    //                     sessionStorage.setItem('currentUser', userResponse.data);
    //                     return userResponse;
    //                 }
    //             } else {
    //                 return throwError(() => new Error(userResponse.error));
    //             }
    //         },
    //     ));
    // }

    updateLogoutAudit(logoutMode: any): Observable<any> {
        return this.apiService
            .get(`users/logout-audit/${logoutMode}`, new CommonRequest())
            .pipe(map((userResponse) => {}));
    }

    changePassword(changeRequest: any): Observable<any> {
        return this.apiService.post(`commons/change-password`, changeRequest).pipe(
            map((forgotResponse) => {
                if (forgotResponse) {
                    return forgotResponse;
                } else {
                    throw throwError(forgotResponse.error);
                }
            })
        );
    }

    forgotUser(forgotRequest: any): Observable<any> {
        return this.apiService.post(`auth/reset-password`, forgotRequest).pipe(
            map((forgotResponse) => {
                if (forgotResponse) {
                    return forgotResponse;
                } else {
                    throw throwError(forgotResponse.error);
                }
            })
        );
    }

    forgotOtpSubmit(forgotOtpRequest: any, id: any): Observable<any> {
        return this.apiService.post(`auth/reset-password/${id}`, forgotOtpRequest).pipe(
            map((forgotOtpResponse) => {
                if (forgotOtpResponse) {
                    return forgotOtpResponse;
                } else {
                    throw throwError(forgotOtpResponse.error);
                }
            })
        );
    }
    resetPassword(resetRequest: any, id: any): Observable<any> {
        return this.apiService.put(`auth/reset-password/${id}`, resetRequest).pipe(
            map((resetResponse) => {
                if (resetResponse) {
                    return resetResponse;
                } else {
                    throw throwError(resetResponse.error);
                }
            })
        );
    }

    generateOtp(otpRequest: any): Observable<any> {
        return this.apiService.post(`otp/generate`, otpRequest).pipe(
            map((otpResponse) => {
                if (otpResponse) {
                    return otpResponse;
                } else {
                    throw throwError(otpResponse.error);
                }
            })
        );
    }

    verifyOtp(verifyRequest: any): Observable<any> {
        return this.apiService.post(`otp/validate`, verifyRequest).pipe(
            map((verifyResponse) => {
                if (verifyResponse) {
                    return verifyResponse;
                } else {
                    throw throwError(verifyResponse.error);
                }
            })
        );
    }

    authenticateAndSendOtp(otpRequest: any): Observable<any> {
        return this.apiService.post(`auth/login`, otpRequest).pipe(
            map((response) => {
                if (response) {
                    if (response.hasOwnProperty('data')) {
                        this.authenticationManager.saveUser(response.data);
                        sessionStorage.setItem('currentUser', response.data);
                        return response;
                    }
                } else {
                    throw throwError(response.error);
                }
            })
        );
    }
    verifyOtpAndGetToken(verifyRequest: any): Observable<any> {
        return this.apiService.post(`auth/login/validate`, verifyRequest).pipe(
            map((authenticationResponse) => {
                if (authenticationResponse) {
                    if (authenticationResponse.data) {

                        this.authenticationManager.saveAuth(authenticationResponse.data);

                         const popupTime = new Date(authenticationResponse.data.tokenExpiryTime).getTime()- (1 * 60 * 1000);
                         this.tokenTimerService.schedulePopup(popupTime);

                    }
                    return authenticationResponse;
                } else {
                    return throwError(() => new Error(authenticationResponse.error));
                }
            })
        );
    }
    autoLogin(username: string): Observable<any> {
        return this.apiService.post('auth/sso-login', { username }).pipe(
            map((response) => {
                if (response?.data) {
                    this.authenticationManager.saveAuth(response.data);
                }
                return response;
            })
        );
    }

    authenticateFileOtp(request: any): Observable<Blob> {
        return this.apiService.postForDownloadFile('file-store/external/consent', request);
    }
}
